var meetupCardBlock = (function () {
  var paramsValue = {},
    queryStringUTM = "",
    paramsExist = "";

  //init function
  function init() {
    //var declaration
    var meetupCountry = document.getElementById("meetupCountry"),
      meetupCity = document.getElementById("meetupCity"),
      meetupSearch = document.getElementById("meetupSearch"),
      meetupSearchBtn = document.getElementById('meetups-card-block__filter-search-btn'),
      clearmeetupFilter = document.getElementById("clearmeetupFilter"),
      clearmeetupFilterNoResults = document.getElementById("clearmeetupFilterNoResults"),
      showMoreBtn = document.querySelector(".btn-meetups-load-more"),
      cookieGeoLocationInfo = Cookie.read(stage_env_cookie_prefix + "cookieGeoLocation") ? bsLib.JSONParse(Cookie.read(stage_env_cookie_prefix + "cookieGeoLocation")) : {},
      cookieCity = cookieGeoLocationInfo.hasOwnProperty("city") ? cookieGeoLocationInfo.city : '',
      cookieCountry = cookieGeoLocationInfo.hasOwnProperty("country") ? cookieGeoLocationInfo.country : '',
      cookieContinent = cookieGeoLocationInfo.hasOwnProperty("continent") ? cookieGeoLocationInfo.continent : '';

    var whiteListParams = ["utm_source", "utm_medium", "utm_platform", "utm_content", "utm_campaign", "utm_campaigncode", "utm_term", ],
      paramsObj = window.location.search
      .slice(1)
      .split("&")
      .map(function (p) {
        return p.split("=");
      })
      .reduce(function (obj, pair) {
        if (pair.length >= 2) {
          obj[pair[0]] = pair[1];
        }
        return obj;
      }, {});

    //Read from cookie
    if (Object.keys(paramsObj).length == 0) {
      var cookieUtmParams = Cookie.read(
        stage_env_cookie_prefix + "user_utm_data"
      );
      if (cookieUtmParams) {
        paramsObj = bsLib.JSONParse(cookieUtmParams);
      }
    }

    // check white list params
    Object.keys(paramsObj).forEach(function (key) {
      if (whiteListParams.indexOf(key) > -1) {
        paramsValue[key] = paramsObj[key];
      }
    });

    function getQueryParams() {
      var params = {};
      window.location.search.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (str, key, value) {
          params[decodeURIComponent(key)] = decodeURIComponent(value || "");
        }
      );

      return params;
    }

    if (cookieGeoLocationInfo.hasOwnProperty("continent") || cookieGeoLocationInfo.hasOwnProperty("country") || cookieGeoLocationInfo.hasOwnProperty("city")) {
      paramsExist = getQueryParams();

      if (!paramsExist.hasOwnProperty("meetup-city") && !paramsExist.hasOwnProperty("meetup-country") && !paramsExist.hasOwnProperty("meetup-search")) {
        var dataAjax = {
          perpage: showMoreBtn.dataset.perpage,
          offset: 0,
          cookieCity: cookieCity,
          cookieCountry: cookieCountry,
          cookieContinent: cookieContinent,
          cookieBased: true,
        };
        meetupCardDataAjax(dataAjax, false);
      }
    } else {
      // XHR request for geo cookie
      bsLib.ajax(
        "GET",
        bsLib.railsHost() + "/ip_geolocation_mapping", {},
        false, {},
        // Success message for user token.
        function (data) {
          if (data.readyState === 4 && data.status === 200) {
            var dataRes = bsLib.JSONParse(data.response);

            if (dataRes.hasOwnProperty("data")) {
              var cookieGeoLocationInfoObj = {
                continent: dataRes.data.continent,
                country: dataRes.data.country,
                city: dataRes.data.city,
              };

              Cookie.create(stage_env_cookie_prefix + "cookieGeoLocation", JSON.stringify(cookieGeoLocationInfoObj), 365);

              var cookieGeoLocationInfo = Cookie.read(stage_env_cookie_prefix + "cookieGeoLocation") ? bsLib.JSONParse(Cookie.read(stage_env_cookie_prefix + "cookieGeoLocation")) : {},
                cookieCity = cookieGeoLocationInfo.city,
                cookieCountry = cookieGeoLocationInfo.country,
                cookieContinent = cookieGeoLocationInfo.continent,
                paramsExist = getQueryParams();

              if (!paramsExist.hasOwnProperty("meetup-city") && !paramsExist.hasOwnProperty("meetup-country") && !paramsExist.hasOwnProperty("meetup-search")) {
                var dataAjax = {
                  perpage: showMoreBtn.dataset.perpage,
                  offset: 0,
                  cookieCity: cookieCity,
                  cookieCountry: cookieCountry,
                  cookieContinent: cookieContinent,
                  cookieBased: true,
                };
                meetupCardDataAjax(dataAjax, false);
              }
            }
          }
        },
        // Custom Error message for user token.
        function () {
          return "ip_geolocation_mapping API is not working";
        }
      );
    }

    // meetup Country DropDown
    if (meetupCountry) {
      new ChosenCustom({
        selector: meetupCountry,
        ID: "selectCountry",
        placeholder: "Country",
        search: true,
        searchPlaceholder: "Search Country...",
      });

      meetupCountry.addEventListener("change", function (evt) {
        var that = this,
          currentCountry = that.value;

        if (currentCountry) {
          updateCity(currentCountry);
        }

        var dataAjax = {
          perpage: showMoreBtn.dataset.perpage,
          offset: 0,
          country: that.value,
          city: meetupCity.value,
          q: meetupSearch.value,
        };

        meetupCardDataAjax(dataAjax, 'country');

        clearmeetupFilter.classList.remove("hide");

        //active
        that.closest(".meetups-card-block__filter-dd").classList.add("active");

        paramsValue["meetup-country"] = that.value;
        paramsValue["meetup-city"] = meetupCity.value;
        paramsValue["meetup-search"] = meetupSearch.value;
        paramsValue["meetups-page"] = 0;

        updateQueryStringParameter();
      });

      function updateCity(currentCountry) {

        for (var i = 0; i < meetupCity.options.length; i++) {
          var meetupCityVal = meetupCity.options[i];
          if (meetupCityVal.hasAttribute('data-country')) {
            meetupCityVal.removeAttribute('data-hide');
            var cityCountry = meetupCityVal.getAttribute('data-country');
            if (cityCountry !== currentCountry) {
              meetupCityVal.setAttribute('data-hide', 'true');
            }
          }
        }

        var cityDropDownList = document.querySelectorAll('#select-dropdown__list-selectcity li');

        for (var j = 0; j < cityDropDownList.length; j++) {
          var cityDropDownListVal = cityDropDownList[j];
          if (cityDropDownListVal.hasAttribute('data-country')) {
            cityDropDownListVal.classList.remove('hide-city');
            var cityListCountry = cityDropDownListVal.getAttribute('data-country');
            if (cityListCountry !== currentCountry) {
              cityDropDownListVal.classList.add('hide-city');
            }
          }
        }
      }
    }

    // meetups citys DropDown
    if (meetupCity) {
      new ChosenCustom({
        selector: meetupCity,
        ID: "selectcity",
        placeholder: "City",
        search: true,
        searchPlaceholder: "Search City...",
      });

      var cityDropDownBtn = document.querySelector('.select-dropdown__button--selectcity'),
        cityDropDownArrow = document.querySelector('.select-dropdown--selectcity .select-arrow');

      cityDropDownBtn.addEventListener("click", function (evt) {
        if (meetupCountry.value) {
          updateCity(meetupCountry.value);
        }
      })
      cityDropDownArrow.addEventListener("click", function (evt) {
        if (meetupCountry.value) {
          updateCity(meetupCountry.value);
        }
      })

      meetupCity.addEventListener("change", function (evt) {
        var that = this,
          selectedCity = that.options[that.selectedIndex],
          selectedCountry = selectedCity.getAttribute('data-country'),
          cityDropDownBtnSpan = document.querySelector('.select-dropdown__button-span.select-dropdown--selectcity');

        cityDropDownBtnSpan.setAttribute('title', that.value);

        if (selectedCountry) {
          if (paramsValue.hasOwnProperty("meetup-country") && paramsValue["meetup-country"] == selectedCountry) {

          } else {
            var countryDropDownWrapper = document.querySelector('.select-dropdown--selectCountry'),
              countryDropDownBtn = document.querySelector('.select-dropdown__button--selectCountry'),
              countryDropDownBtnSpan = document.querySelector('.select-dropdown__button-span.select-dropdown--selectCountry');

            for (var i = 0; i < meetupCountry.options.length; i++) {
              meetupCountry.options[i].removeAttribute('selected');
            }
            for (var j = 0; j < meetupCountry.options.length; j++) {
              if (meetupCountry.options[j].value === selectedCountry) {
                meetupCountry.selectedIndex = i;
                meetupCountry.options[j].setAttribute('selected', 'selected');
                countryDropDownWrapper.parentElement.classList.add("active");
                countryDropDownBtn.setAttribute('data-value', selectedCountry);
                countryDropDownBtnSpan.textContent = meetupCountry.options[j].text;
                break;
              }
            }
          }
        }

        var dataAjax = {
          perpage: showMoreBtn.dataset.perpage,
          offset: 0,
          country: meetupCountry.value,
          city: that.value,
          q: meetupSearch.value,
        };

        meetupCardDataAjax(dataAjax, 'city');

        clearmeetupFilter.classList.remove("hide");

        //active
        that.closest(".meetups-card-block__filter-dd").classList.add("active");

        paramsValue["meetup-country"] = selectedCountry;
        paramsValue["meetup-city"] = that.value;
        paramsValue["meetup-search"] = meetupSearch.value;
        paramsValue["meetups-page"] = 0;

        updateQueryStringParameter();
      });
    }

    // meetup Search
    if (meetupSearch) {
      meetupSearch.addEventListener(
        "keyup",
        function (evt) {
          var that = this,
            inputVal = that.value.trim();
          if (inputVal !== "" && inputVal.length) {
            meetupSearch.classList.add("active");
          } else {
            meetupSearch.classList.remove("active");
          }
        },
        false
      );

      // Execute a function when the user presses a key on the keyboard
      meetupSearch.addEventListener(
        "keypress",
        function (evt) {
          // If the user presses the "Enter" key on the keyboard
          if (evt.key === "Enter") {
            evt.preventDefault();

            var that = this,
              dataAjax = {
                perpage: showMoreBtn.dataset.perpage,
                offset: 0,
                country: meetupCountry.value,
                city: meetupCity.value,
                q: that.value.trim(),
              };

            if (that.value.trim() === "" && window.location.href.indexOf("meetup-search") > 0) {
              meetupCardDataAjax(dataAjax, 'search');
            } else if (that.value.trim() !== "") {
              meetupCardDataAjax(dataAjax, 'search');
            }

            if (that.value.trim() === "" && meetupCountry.value === "" && meetupCity.value === "") {
              clearmeetupFilter.classList.add("hide");
            } else {
              clearmeetupFilter.classList.remove("hide");
            }

            paramsValue["meetup-country"] = meetupCountry.value;
            paramsValue["meetup-city"] = meetupCity.value;
            paramsValue["meetup-search"] = that.value.trim();
            paramsValue["meetups-page"] = 0;

            updateQueryStringParameter();
          }
        },
        false
      );
    }

    if (meetupSearchBtn) {
      meetupSearchBtn.addEventListener(
        'click',
        function (evt) {
          evt.preventDefault();

          var dataAjax = {
            perpage: showMoreBtn.dataset.perpage,
            offset: 0,
            country: meetupCountry.value,
            city: meetupCity.value,
            q: meetupSearch.value.trim(),
          };

          if (meetupSearch.value.trim() === "" && window.location.href.indexOf("meetup-search") > 0) {
            meetupCardDataAjax(dataAjax, 'search');
          } else if (meetupSearch.value.trim() !== "") {
            meetupCardDataAjax(dataAjax, 'search');
          }

          if (meetupSearch.value.trim() === "" && meetupCountry.value === "" && meetupCity.value === "") {
            clearmeetupFilter.classList.add("hide");
          } else {
            clearmeetupFilter.classList.remove("hide");
          }

          paramsValue["meetup-country"] = meetupCountry.value;
          paramsValue["meetup-city"] = meetupCity.value;
          paramsValue["meetup-search"] = meetupSearch.value.trim();
          paramsValue["meetups-page"] = 0;

          updateQueryStringParameter();
        },
        false
      );
    }

    // attach events on page load
    cardAmpEvents();

    // meetup Clear Button
    if (clearmeetupFilter) {
      clearmeetupFilter.addEventListener('click', clearAllFilters);
    }

    if (clearmeetupFilterNoResults) {
      clearmeetupFilterNoResults.addEventListener('click', clearAllFilters);
    }

    function clearAllFilters(evt) {
      evt.preventDefault();
      var cookieGeoLocationInfo = Cookie.read(stage_env_cookie_prefix + "cookieGeoLocation") ? bsLib.JSONParse(Cookie.read(stage_env_cookie_prefix + "cookieGeoLocation")) : {},
        dataAjax = {
          perpage: showMoreBtn.dataset.perpage,
          offset: 0,
          country: "",
          city: "",
          q: "",
        };
      
      if (cookieGeoLocationInfo.hasOwnProperty("continent") || cookieGeoLocationInfo.hasOwnProperty("country") || cookieGeoLocationInfo.hasOwnProperty("city")) {
        var cookieCity = cookieGeoLocationInfo.city,
          cookieCountry = cookieGeoLocationInfo.country,
          cookieContinent = cookieGeoLocationInfo.continent;
        
        dataAjax.cookieBased = true;
        dataAjax.cookieCity = cookieCity;
        dataAjax.cookieCountry = cookieCountry;
        dataAjax.cookieContinent = cookieContinent;
      }

      meetupCardDataAjax(dataAjax, false);

      //remove active class
      meetupCountry.closest(".meetups-card-block__filter-dd").classList.remove("active");
      meetupCity.closest(".meetups-card-block__filter-dd").classList.remove("active");
      meetupSearch.classList.remove("active");

      var cityDropDownList = document.querySelectorAll("#select-dropdown__list-selectcity li.select-dropdown__list-item");

      for (var i = 0; i < meetupCity.options.length; i++) {
        if (meetupCity.options[i].hasAttribute('data-country')) {
          meetupCity.options[i].removeAttribute('data-hide');
        }
      }

      if (cityDropDownList) {
        for (var j = 0; j < cityDropDownList.length; j++) {
          if (cityDropDownList[j].hasAttribute('data-country')) {
            cityDropDownList[j].classList.remove('hide-city');
          }
        }
      }

      //chosen reset
      new ChosenCustom({
        selector: meetupCountry,
        reset: true,
      });

      new ChosenCustom({
        selector: meetupCity,
        reset: true,
      });

      //search reset
      meetupSearch.value = "";

      clearmeetupFilter.classList.add("hide");

      delete paramsValue["meetup-country"];
      delete paramsValue["meetup-city"];
      delete paramsValue["meetup-search"];
      delete paramsValue["meetups-page"];

      updateQueryStringParameter();
    }

    //meetup Pagination show more button
    if (showMoreBtn) {
      showMoreBtn.addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();

          var cookieGeoLocationInfo = Cookie.read(stage_env_cookie_prefix + "cookieGeoLocation") ? bsLib.JSONParse(Cookie.read(stage_env_cookie_prefix + "cookieGeoLocation")) : {},
						paramsExist = getQueryParams();

					if (cookieGeoLocationInfo.hasOwnProperty("continent") || cookieGeoLocationInfo.hasOwnProperty("country") || cookieGeoLocationInfo.hasOwnProperty("city")) {
						var cookieCity = cookieGeoLocationInfo.city,
							cookieCountry = cookieGeoLocationInfo.country,
							cookieContinent = cookieGeoLocationInfo.continent;
					}

          var that = this,
            dataAjax = {
              perpage: that.dataset.perpage,
              offset: that.dataset.offset,
              country: meetupCountry.value,
              city: meetupCity.value,
              q: meetupSearch.value.trim(),
            };

          if (!paramsExist.hasOwnProperty("meetup-city") && !paramsExist.hasOwnProperty("meetup-country") && !paramsExist.hasOwnProperty("meetup-search")) {
            dataAjax.cookieBased = true;
            dataAjax.cookieCity = cookieCity;
            dataAjax.cookieCountry = cookieCountry;
            dataAjax.cookieContinent = cookieContinent;
          }

          meetupCardDataAjax(dataAjax, false);

          paramsValue["meetup-country"] = meetupCountry.value;
          paramsValue["meetup-city"] = meetupCity.value;
          paramsValue["meetup-search"] = meetupSearch.value.trim();
          paramsValue["meetups-page"] = 0;

          updateQueryStringParameter();
        },
        false
      );
    }
  }

  function meetupCardDataAjax(dataAjax, eventsAmp) {
    var pageBtn = document.querySelector(".btn-meetups-load-more"),
      noResultsmeetups = document.getElementById("noResultsmeetups"),
      loaderContent = document.querySelector(
        ".meetups-card-block-loading-container"
      );

    pageBtn.classList.add("visible-hide");
    noResultsmeetups.classList.add("hide");

    if (loaderContent) {
      loaderContent.classList.remove("hide");
    }

    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/wp-admin/admin-ajax.php",
      bsLib.extend({
          action: "bstack_meetup_card_data",
          security: ajax_initialize_script.ajax_nonce,
        },
        dataAjax
      ),
      true, //async
      {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }, //request header
      function (data) {
        if (data.readyState === 4) {
          var dataRequest = bsLib.JSONParse(data.response),
            meetupsCardRow = document.querySelector(
              ".meetups-card-block .meetups-card-block__row"
            );

          if (dataRequest.status) {
            if (dataAjax.offset > 0) {
              meetupsCardRow.insertAdjacentHTML("beforeend", dataRequest.html);
            } else {
              meetupsCardRow.innerHTML = dataRequest.html;
            }
            pageBtn.dataset.offset = dataRequest.offset;
            pageBtn.dataset.filtered = dataRequest.filtered;

            if (loaderContent) {
              loaderContent.classList.add("hide");
            }

            if (dataRequest.filtered == 0) {
              noResultsmeetups.classList.remove("hide");
            }

            if (dataRequest.filtered < 3) {
              meetupsCardRow.classList.add("meetups-card-block__row--flex-start");
            } else {
              meetupsCardRow.classList.remove("meetups-card-block__row--flex-start");
            }

            if (dataRequest.offset * dataAjax.perpage < dataRequest.filtered) {
              pageBtn.classList.remove("visible-hide");
            }

            lazyLoading.show();

            cardAmpEvents();

            if (eventsAmp) {
              var dataAmpJson;
              if (eventsAmp == 'city') {
                dataAmpJson = {
                  action: 'filter selected',
                  type: "city",
                  value: meetupCity.value,
                  results: dataRequest.filtered
                }
              }

              if (eventsAmp == 'country') {
                dataAmpJson = {
                  action: 'filter selected',
                  type: "country",
                  value: meetupCountry.value,
                  results: dataRequest.filtered,
                  signedin_state: wpUserLoggedIn
                }
              }

              if (eventsAmp == 'search') {
                dataAmpJson = {
                  action: 'search initiated',
                  searchquery: meetupSearch.value,
                  results: dataRequest.filtered,
                  signedin_state: wpUserLoggedIn
                }
              }

              WebEventTracker.logEvent(EDS.webEvents, "InteractedWithMeetupsPage", dataAmpJson);
            }
          }
        }
      }, //success
      function () {} //error object
    );
  }

  function cardAmpEvents() {
    var cardsBtn = document.querySelectorAll('.meetups-card-block__wrapper .meetups-card-block__btn');
    for (var i = 0; i < cardsBtn.length; i++) {
      cardsBtn[i].addEventListener("click", function () {
        var that = this,
          btnTitle = that.innerText,
          destinationURL = that.getAttribute("href"),
          mainParent = this.parentNode.parentNode,
          eventDate = mainParent.querySelector('.meetups-card-block__date').innerText,
          eventCity = mainParent.querySelector('.meetups-card-block__city').innerText;

        WebEventTracker.logEvent(EDS.webEvents, "InteractedWithMeetupsPage", {
          'action': 'click',
          'clicked title': btnTitle,
          'destination url': destinationURL,
          'city': eventCity,
          'date': eventDate,
          'signedin_state': wpUserLoggedIn
        });
      });
    }
  }

  // Function to update Query String in the URL
  // https://jsfiddle.net/bp3tmuxh/1/
  function updateQueryStringParameter() {
    if (paramsValue.hasOwnProperty("meetup-country")) {
      if (paramsValue["meetup-country"] === "") {
        delete paramsValue["meetup-country"];
      }
    }

    if (paramsValue.hasOwnProperty("meetup-city")) {
      if (paramsValue["meetup-city"] === "") {
        delete paramsValue["meetup-city"];
      }
    }

    if (paramsValue.hasOwnProperty("meetup-search")) {
      if (paramsValue["meetup-search"] === "") {
        delete paramsValue["meetup-search"];
      }
    }

    if (paramsValue.hasOwnProperty("meetups-page")) {
      if (paramsValue["meetups-page"] === 0) {
        delete paramsValue["meetups-page"];
      }
    }

    if (Object.keys(paramsValue).length > 0) {
      queryStringUTM =
        "?" +
        Object.keys(paramsValue)
        .map(function (key) {
          return key + "=" + paramsValue[key];
        })
        .join("&");
    } else {
      queryStringUTM = "";
    }

    var uri = window.location.href.split("?")[0];

    if (history.pushState) {
      var hash = "";
      if (uri.indexOf("#") !== -1) {
        hash = uri.replace(/.*#/, "#");
        uri = uri.replace(/#.*/, "");
      }

      //update referrer
      var newReferrer = window.location.href;
      Object.defineProperty(document, "referrer", {
        configurable: true,
        get: function () {
          return newReferrer;
        },
      });

      window.history.pushState({
          path: window.location.href
        },
        "",
        uri + queryStringUTM + hash
      );
    }
  }
  init();
})();